import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

/**
 * Tab画面パーツ
 */

export function a11yProps(index: any) {
	return {
		id: `scrollable-auto-tab-${index}`,
		'aria-controls': `scrollable-auto-tabpanel-${index}`,
	};
}
export interface tabsprop {
	value: any ;
	setValue: any;
	tablabel: string[];
}

export function ApolloTabsVariable (props:tabsprop) {

	const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
		props.setValue(newValue);
	};

	return (
		<Tabs value={ props.value} onChange={handleChange} aria-label="creative tabs">
			{props.tablabel.map((table, idx:number) => {
				return (
					<Tab label={table} {...a11yProps(idx)} />
				)
			})}
		</Tabs>
	)
}
export interface TabPanelProps {
	children?: React.ReactNode;
	index: any;
	value: any;
}
export function ApolloTabPanel(props: TabPanelProps) {
	const {children, value, index, ...other} = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}>
			{children}
		</div>
	);
}
